import React,{useState} from 'react'
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import UploadProductCSVPopup from '../../Popups/UploadProductCSVPopup';
import { Tag } from 'primereact/tag';


const UploadProductCsvToolbar = () => {

    const [visible, setVisible] = useState(false);
   
    const startContent = (
        <React.Fragment>
                        <Tag value="New" severity="warning" rounded></Tag>
            Bulk upload : Now you can upload products directly from Excel
        </React.Fragment>
    );


    const endContent = (
        <React.Fragment>
            <Button label="Import products from Excel sheet" icon="pi pi-upload" iconPos="right" onClick={() => setVisible(true)}/>
        </React.Fragment>
    );

  return (
    <>
    <Toolbar start={startContent} end={endContent} />
    <Dialog  visible={visible} onHide={() => {if (!visible) return; setVisible(false); }}
                style={{ width: '50vw' , height:'85vh'}} breakpoints={{ '960px': '75vw', '641px': '100vw' }}>
                <UploadProductCSVPopup/>
            </Dialog></>
  )
}

export default UploadProductCsvToolbar
